// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutMe_rightContent__Os98z {
    float: right;
    width: 20%;
    margin-top: 5%;
    margin-right: 12.5%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.AboutMe_pic__sj00M {
    width: 100%;
    height: auto;
    margin-top: 2vw;
    border-radius: 8%;
    border: 5px solid var(--frame-color);
    box-shadow: 0 0 10px 5px var(--shadow-color);
}
.AboutMe_info__WEtcJ {
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: hidden;
}
.AboutMe_header__Z8Zrc {
    font-size: 6vw;
    margin: 1% 0 0 0;
    font-family: "Quantify", sans-serif;
    line-height: 1.7;
    font-stretch: 110%;
    font-weight: 180;
    color: var(--title-color);
}
.AboutMe_headerContainer__wg-FA {
    text-align: center;
}
.AboutMe_text__WByfB {
    font-size: 2vw;
    font-family: "Astonpoliz", sans-serif;
    color: var(--text-color);
}
.AboutMe_uniLogo__\\+7Ffq {
    height: auto;
    width: 20rem;
    transition: all 0.3s ease;
}
.AboutMe_uniLogo__\\+7Ffq:hover {
    transform: translateY(+5px);
}
.AboutMe_bio__kBB34 {
    margin-top: 7rem;
    margin-left: 12.5%;
    width: 50%;
    text-align: left;
}
.AboutMe_list__pCp0w {
    line-height: 1.5;
    list-style: none;
    padding-left: 1em;
}
.AboutMe_list__pCp0w li {
    position: relative;
    padding-left: 1.2em;
    margin-bottom: 10px;
}
.AboutMe_list__pCp0w li::before {
    content: "•";
    color: var(--text-color);
    font-weight: bold;
    position: absolute;
    left: 0;
}
.AboutMe_cv__nEi-G {
    display: flex;
    padding-left: 22.5vw;
}
.AboutMe_button__tF1LP {
    display: inline-block;
    font-size: 2vw;
}
.AboutMe_button__tF1LP a {
    display: inline-block;
    color: var(--bg-color);
    background-color: var(--title-color);
    margin-left: 1vw;
    margin-top: 0.7vw;
    padding: 15% 30%;
    border-radius: 1vw;
    box-shadow: -5px 5px 5px 0px var(--shadow-color);
    text-decoration: none;
    transition: all 0.3s ease;
}
.AboutMe_button__tF1LP a:hover {
    background-color: var(--hover-color);
    transform: translateY(-2px);
    box-shadow: 0 0 5px 5px var(--shadow-color);
}
.AboutMe_contact__MqGM4 {
    position: relative;
    overflow: hidden;
    margin-left: 15vw;
    margin-top: -7rem;
    width: 42vw;
}
.AboutMe_bgText__K0idY {
    position: absolute;
    width: 100%;
    z-index: -1;
    top: 2vh;
    right: 0;
    left: -5%;
    bottom: 0;
    text-align: center;
    font-size: 9vw;
    opacity: 0.12;
    font-family: "Quantify";
    font-weight: 900;
    transform: scale(1.1);
    letter-spacing: -0.02em;
}
.AboutMe_smolCont__a5PYn {
    display: flex;
    flex-direction: row;
    margin-left: 2vw;
}
.AboutMe_social__aLQRW {
    width: 13vw;
    flex: 1 1;
    list-style-type: none;
    padding: 4% 0 0 0;
}
.AboutMe_official__0EzD3 {
    margin-right: 0;
    width: auto;
    flex: 1 1;
    padding-top: 12%;
    margin-left: 0;
    padding-left: 0;
    margin-right: 0;
    padding-right: 0;
    text-align: right;
    list-style-type: none;
}
.AboutMe_logos__uUmLA {
    height: 2vw;
    width: auto;
}
/*-----------------------------PORTRAIT MODE---------------------------------------------------------------PORTRAIT MODE-----------------------------------------------------------*/
@media (max-aspect-ratio: 1/1) {
    .AboutMe_info__WEtcJ {
        display: flex;
        flex-direction: column;
    }
    .AboutMe_headerContainer__wg-FA {
        width: 100vw;
    }
    .AboutMe_header__Z8Zrc {
        width: 100%;
        font-size: 12vw;
        margin-left: -3vw;
    }
    .AboutMe_rightContent__Os98z {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .AboutMe_pic__sj00M {
        position: relative;
        width: 80vw;
        height: auto;
        margin: 3vh auto 0 auto;
        border-radius: 8vw;
        border: 5px solid var(--frame-color);
        box-shadow: -5px 5px 10px 0 var(--shadow-color);
    }
    .AboutMe_bio__kBB34 {
        margin-top: 5vh;
        margin-left: 0vw;
        font-size: 6vh;
        width: 95vw;
        height: 70vw;
        text-align: left;
    }
    .AboutMe_cv__nEi-G {
        display: flex;
        height: 15vw;
        width: 100vw;
        margin-top: 10vh;
        align-items: flex-start;
    }
    .AboutMe_uniLogo__\\+7Ffq {
        height: 1rem;
        width: auto;
    }
    .AboutMe_button__tF1LP {
        display: inline-block;
        opacity: 1;
        font-size: 5vw;
    }
    .AboutMe_button__tF1LP a {
        display: inline-block;
        color: var(--bg-color);
        background-color: var(--title-color);
        padding: 2.5vw 5vw;
        border-radius: 3vw;
        box-shadow: -5px 5px 5px 0px var(--shadow-color);
        text-decoration: none;
        transition: all 0.3s ease;
    }
    .AboutMe_button__tF1LP a:hover {
        background-color: var(--hover-color);
        transform: translateY(-2px);
        box-shadow: 0 0 5px 5px var(--shadow-color);
    }
    .AboutMe_text__WByfB {
        font-size: 5vw;
    }
    .AboutMe_contact__MqGM4 {
        position: relative;
        width: 95vw;
        height: auto;
        margin-top: 0vh;
        padding: 0%;
        margin-left: 5vw;
    }
    .AboutMe_bgText__K0idY {
        position: absolute;
        width: 45vw;
        z-index: -1;
        top: 13vw;
        right: 0;
        left: 2vw;
        bottom: 0;
        text-align: center;
        font-size: 12vw;
        opacity: 0.25;
        font-family: "Quantify";
        font-weight: 400;
        letter-spacing: 0;
        color: var(--title-color);
    }
    .AboutMe_smolCont__a5PYn {
        flex-direction: column;
        width: 95vw;
        margin-bottom: 7vh;
    }
    .AboutMe_official__0EzD3 {
        text-align: right;
        width: 60vw;
        margin-left: -4vw;
        margin-top: 0;
        padding-top: 2vw;
    }
    .AboutMe_social__aLQRW {
        text-align: left;
        padding-left: 7vw;
        width: 60vw;
        margin-left: 44vw;
        margin-bottom: 0;
        padding-bottom: 0;
    }
    .AboutMe_logos__uUmLA {
        height: 5vw;
        width: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutMe.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,4CAA4C;AAChD;AACA;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,qCAAqC;IACrC,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gDAAgD;IAChD,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,2CAA2C;AAC/C;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,SAAO;IACP,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,SAAO;IACP,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA,oLAAoL;AACpL;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,kBAAkB;QAClB,oCAAoC;QACpC,+CAA+C;IACnD;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,cAAc;IAClB;IACA;QACI,qBAAqB;QACrB,sBAAsB;QACtB,oCAAoC;QACpC,kBAAkB;QAClB,kBAAkB;QAClB,gDAAgD;QAChD,qBAAqB;QACrB,yBAAyB;IAC7B;IACA;QACI,oCAAoC;QACpC,2BAA2B;QAC3B,2CAA2C;IAC/C;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,eAAe;QACf,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,SAAS;QACT,QAAQ;QACR,SAAS;QACT,SAAS;QACT,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;IAC7B;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,WAAW;QACX,iBAAiB;QACjB,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,WAAW;IACf;AACJ","sourcesContent":[".rightContent {\n    float: right;\n    width: 20%;\n    margin-top: 5%;\n    margin-right: 12.5%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.pic {\n    width: 100%;\n    height: auto;\n    margin-top: 2vw;\n    border-radius: 8%;\n    border: 5px solid var(--frame-color);\n    box-shadow: 0 0 10px 5px var(--shadow-color);\n}\n.info {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n}\n.header {\n    font-size: 6vw;\n    margin: 1% 0 0 0;\n    font-family: \"Quantify\", sans-serif;\n    line-height: 1.7;\n    font-stretch: 110%;\n    font-weight: 180;\n    color: var(--title-color);\n}\n.headerContainer {\n    text-align: center;\n}\n.text {\n    font-size: 2vw;\n    font-family: \"Astonpoliz\", sans-serif;\n    color: var(--text-color);\n}\n.uniLogo {\n    height: auto;\n    width: 20rem;\n    transition: all 0.3s ease;\n}\n.uniLogo:hover {\n    transform: translateY(+5px);\n}\n.bio {\n    margin-top: 7rem;\n    margin-left: 12.5%;\n    width: 50%;\n    text-align: left;\n}\n.list {\n    line-height: 1.5;\n    list-style: none;\n    padding-left: 1em;\n}\n.list li {\n    position: relative;\n    padding-left: 1.2em;\n    margin-bottom: 10px;\n}\n.list li::before {\n    content: \"•\";\n    color: var(--text-color);\n    font-weight: bold;\n    position: absolute;\n    left: 0;\n}\n.cv {\n    display: flex;\n    padding-left: 22.5vw;\n}\n.button {\n    display: inline-block;\n    font-size: 2vw;\n}\n.button a {\n    display: inline-block;\n    color: var(--bg-color);\n    background-color: var(--title-color);\n    margin-left: 1vw;\n    margin-top: 0.7vw;\n    padding: 15% 30%;\n    border-radius: 1vw;\n    box-shadow: -5px 5px 5px 0px var(--shadow-color);\n    text-decoration: none;\n    transition: all 0.3s ease;\n}\n.button a:hover {\n    background-color: var(--hover-color);\n    transform: translateY(-2px);\n    box-shadow: 0 0 5px 5px var(--shadow-color);\n}\n.contact {\n    position: relative;\n    overflow: hidden;\n    margin-left: 15vw;\n    margin-top: -7rem;\n    width: 42vw;\n}\n.bgText {\n    position: absolute;\n    width: 100%;\n    z-index: -1;\n    top: 2vh;\n    right: 0;\n    left: -5%;\n    bottom: 0;\n    text-align: center;\n    font-size: 9vw;\n    opacity: 0.12;\n    font-family: \"Quantify\";\n    font-weight: 900;\n    transform: scale(1.1);\n    letter-spacing: -0.02em;\n}\n.smolCont {\n    display: flex;\n    flex-direction: row;\n    margin-left: 2vw;\n}\n.social {\n    width: 13vw;\n    flex: 1;\n    list-style-type: none;\n    padding: 4% 0 0 0;\n}\n.official {\n    margin-right: 0;\n    width: auto;\n    flex: 1;\n    padding-top: 12%;\n    margin-left: 0;\n    padding-left: 0;\n    margin-right: 0;\n    padding-right: 0;\n    text-align: right;\n    list-style-type: none;\n}\n.logos {\n    height: 2vw;\n    width: auto;\n}\n/*-----------------------------PORTRAIT MODE---------------------------------------------------------------PORTRAIT MODE-----------------------------------------------------------*/\n@media (max-aspect-ratio: 1/1) {\n    .info {\n        display: flex;\n        flex-direction: column;\n    }\n    .headerContainer {\n        width: 100vw;\n    }\n    .header {\n        width: 100%;\n        font-size: 12vw;\n        margin-left: -3vw;\n    }\n    .rightContent {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    .pic {\n        position: relative;\n        width: 80vw;\n        height: auto;\n        margin: 3vh auto 0 auto;\n        border-radius: 8vw;\n        border: 5px solid var(--frame-color);\n        box-shadow: -5px 5px 10px 0 var(--shadow-color);\n    }\n    .bio {\n        margin-top: 5vh;\n        margin-left: 0vw;\n        font-size: 6vh;\n        width: 95vw;\n        height: 70vw;\n        text-align: left;\n    }\n    .cv {\n        display: flex;\n        height: 15vw;\n        width: 100vw;\n        margin-top: 10vh;\n        align-items: flex-start;\n    }\n    .uniLogo {\n        height: 1rem;\n        width: auto;\n    }\n    .button {\n        display: inline-block;\n        opacity: 1;\n        font-size: 5vw;\n    }\n    .button a {\n        display: inline-block;\n        color: var(--bg-color);\n        background-color: var(--title-color);\n        padding: 2.5vw 5vw;\n        border-radius: 3vw;\n        box-shadow: -5px 5px 5px 0px var(--shadow-color);\n        text-decoration: none;\n        transition: all 0.3s ease;\n    }\n    .button a:hover {\n        background-color: var(--hover-color);\n        transform: translateY(-2px);\n        box-shadow: 0 0 5px 5px var(--shadow-color);\n    }\n    .text {\n        font-size: 5vw;\n    }\n    .contact {\n        position: relative;\n        width: 95vw;\n        height: auto;\n        margin-top: 0vh;\n        padding: 0%;\n        margin-left: 5vw;\n    }\n    .bgText {\n        position: absolute;\n        width: 45vw;\n        z-index: -1;\n        top: 13vw;\n        right: 0;\n        left: 2vw;\n        bottom: 0;\n        text-align: center;\n        font-size: 12vw;\n        opacity: 0.25;\n        font-family: \"Quantify\";\n        font-weight: 400;\n        letter-spacing: 0;\n        color: var(--title-color);\n    }\n    .smolCont {\n        flex-direction: column;\n        width: 95vw;\n        margin-bottom: 7vh;\n    }\n    .official {\n        text-align: right;\n        width: 60vw;\n        margin-left: -4vw;\n        margin-top: 0;\n        padding-top: 2vw;\n    }\n    .social {\n        text-align: left;\n        padding-left: 7vw;\n        width: 60vw;\n        margin-left: 44vw;\n        margin-bottom: 0;\n        padding-bottom: 0;\n    }\n    .logos {\n        height: 5vw;\n        width: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightContent": `AboutMe_rightContent__Os98z`,
	"pic": `AboutMe_pic__sj00M`,
	"info": `AboutMe_info__WEtcJ`,
	"header": `AboutMe_header__Z8Zrc`,
	"headerContainer": `AboutMe_headerContainer__wg-FA`,
	"text": `AboutMe_text__WByfB`,
	"uniLogo": `AboutMe_uniLogo__+7Ffq`,
	"bio": `AboutMe_bio__kBB34`,
	"list": `AboutMe_list__pCp0w`,
	"cv": `AboutMe_cv__nEi-G`,
	"button": `AboutMe_button__tF1LP`,
	"contact": `AboutMe_contact__MqGM4`,
	"bgText": `AboutMe_bgText__K0idY`,
	"smolCont": `AboutMe_smolCont__a5PYn`,
	"social": `AboutMe_social__aLQRW`,
	"official": `AboutMe_official__0EzD3`,
	"logos": `AboutMe_logos__uUmLA`
};
export default ___CSS_LOADER_EXPORT___;
